import React, { ReactNode } from "react";

import { Pill } from "../../../constants/Styles";
import * as styledElements from "./LineItemStyles";
import { LineItemDescription } from "./LineItemStyles";

const LineItem = ({
  leftText,
  rightText,
  bottomBorder = false,
  topBorder = false,
  description,
  isUpdating,
}: {
  leftText?: string | ReactNode;
  rightText?: string | ReactNode;
  bottomBorder?: boolean;
  topBorder?: boolean;
  description?: ReactNode;
  isUpdating?: boolean;
}) => {
  return (
    <styledElements.DetailBlock>
      <styledElements.DetailLine
        bottomBorder={bottomBorder}
        topBorder={topBorder}
        isBoardBreakdown={!!description}
      >
        {leftText ? (
          <styledElements.Label>{leftText}:</styledElements.Label>
        ) : (
          <div />
        )}
        <styledElements.ValueText>
          {isUpdating ? <Pill width="100px" /> : rightText}
        </styledElements.ValueText>
      </styledElements.DetailLine>
      {description && <LineItemDescription>{description}</LineItemDescription>}
    </styledElements.DetailBlock>
  );
};

export default LineItem;
